<template>
    <div class="active">
        <div class="active_title">
            <div class="left">
                {{ name }}
            </div>
            <div class="right" @click="showMeeting">
                更多 >
            </div> 
        </div>

        <div class="list_box">
            <div class="list_item " v-for="(item,index) in list" :key="index" @click="showMeetingDetail( item )" @mouseover="hoverIndex = index" @mouseout="hoverIndex = null"  >
                <div class="img_content_box">
                    <div class="img_box" :class="hoverIndex == index ? 'hvr-grow' : '' ">
                        <img :src="item.meetingImg" v-if="item.meetingImg && item.meetingImg.indexOf('http') != -1" alt="">
                        <img :src="$ImgUrl + item.meetingImg" v-if="item.meetingImg && item.meetingImg.indexOf('http') == -1" alt="">
                        <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.meetingImg" alt="">
                    </div>
                </div>
                <div class="info_box">
                    <div class="list_name">
                        <span>{{ item.meetingName }}</span>
                    </div>
                    <div class="list_dept">
                        {{ item.deptName }}
                    </div>
                    <div class="list_time same">
                      <span class="el-icon-timer"></span> 时间:  {{ item.startTime }}
                    </div>
                    <div class="list_position same">
                      <span class="el-icon-location-outline"></span>  地点:  {{ item.meetingAddress }}
                    </div>
                    <div class="list_count same">
                       <span class="el-icon-user"></span>  人数: {{ item.memberCount }}
                    </div>
                    <div class="list_status">
                        <div class="left_status">
                            <span :class="item.meetingStatus == 3 ?  'el-icon-remove' :'el-icon-success'  "></span>
                            {{ item.meetingStatusName  }}
                        </div>
                        <div class="right_show_more">
                            查看更多 >
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            id: {
                type: Number,
                required: true
            },
            index: {
                type:Number,
            }
            
        },
        data() {
            return {
                list: [],
                hoverIndex:null,
            }
        },
        mounted () {
            this.getList()
        },
        methods: {
            // 获取列表
            async getList () {
                let meetingType = `${ this.id }`
                let buildingPartyType = "2"
                let pageSize = 2
                let res = await this.$axios.post("/lencon/pc/index/index_meeting_list", { meetingType, buildingPartyType, pageSize })
                if ( res.data.code == 1 ) {
                    this.list = res.data.res
                }
            },
            // 会议详情
            showMeetingDetail ( item ) {
                this.$router.push({
                    path: `/MeetingDetail/${item.meetingId}`
                })
            },
            // 会议展示
            showMeeting () {
                this.$router.push({
                    path:"/MeetingShow",
                    query: {
                        activeMain: this.index
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
.active {
    width: 580px;
    box-sizing: border-box;
    overflow: hidden;
    .active_title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #2767c4 ;
        .left {
            font-size: 24px;
            color: #2767c4 ;
            font-weight: bold;
        }
        .right {
            font-size: 14px;
            color: #B3B3B3;
            cursor: pointer;
        }
    }
    .list_box {
        width: 100%;
        .list_item {
            width: 100%;
            display: flex;
            margin: 20px 0;
            cursor: pointer;
            .img_content_box {
                width: 275px;
                height: 165px;
                overflow: hidden;
                .img_box {
                    width: 275px;
                    height: 165px;
                    img {
                        width: 275px;
                        height: 165px;
                    }
                }
            }
            .info_box {
                margin-left: 20px;
                width: 275px;
                .list_name {
                    font-size: 18px;
                    width: 275px;
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    span {
                        word-break: break-all;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .list_dept {
                    font-size: 16px;
                    color: #B3B3B3;
                    line-height: 30px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .same {
                    color: #B3B3B3;
                    font-size: 14px;
                    line-height: 28px;
                }
                .list_status {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 40px;
                    .left_status {
                        color: #2767c4 ;
                        font-weight: bold;
                    }
                    .right_show_more {
                        font-size: 14px;
                        color: #8e8e8e;
                    }
                }
            }
        }
        
    }
}
</style>